// @flow
import React from 'react'
import { Link } from 'react-router-dom'

export const EmailSendError = (): any => {
  return (
    <div className='pw-reset-password'>
      <span className='login__accent' />
      <div className='login__header'>
        <h3 className='login__title'>Something went wrong</h3>
        <h4 className='login__subtitle'>There was a problem sending you an email. Please double-check the email you submitted and try again.</h4>
      </div>
      <Link to='/forgot-password' className='pw-reset-password__link'>Return to Forgot Password Page</Link>
    </div>
  )
}

EmailSendError.displayName = 'EmailSendError'

export default EmailSendError
